// src/App.js

import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TopBanner from "./components/TopBanner";
import Footer from "./components/Footer";

// Lazy-loaded public sections
const AllAudioReleases = lazy(() => import("./components/Sections/AudioReleases"));
const MayaSenClass = lazy(() => import("./components/Sections/MayaClass"));
const ImageGallery = lazy(() => import("./components/Sections/ImageGallery"));
const EventsGallery = lazy(() => import("./components/Sections/EventsKRC"));
const Publications = lazy(() => import("./components/Sections/Publications"));
const AboutSection = lazy(() => import("./components/Sections/About"));
const WorkshopSection = lazy(() => import("./components/Sections/WorkShops"));

// Lazy-loaded Admin
const AdminPanel = lazy(() => import("./components/admin/AdminPanel"));
const AdminLogin = lazy(() => import("./components/admin/AdminLogin"));
const AllAudioReleaseAdmin = lazy(() => import("./components/admin/AllAudioReleaseAdmin"));
const MayaClassAdmin = lazy(() => import("./components/admin/MayaClassAdmin"));
const WorkshopsAdmin = lazy(() => import("./components/admin/WorkshopsAdmin"));
const EventsKRCAdmin = lazy(() => import("./components/admin/EventsKRCAdmin"));
const ImageGalleryAdmin = lazy(() => import("./components/admin/ImageGalleryAdmin"));
const PublicationsAdmin = lazy(() => import("./components/admin/PublicationsAdmin"));

function App() {
  return (
    <Router>
      <Suspense fallback={<p>Loading...</p>}>
        <Routes>
          {/* Public Website */}
          <Route
            path="/"
            element={
              <div>
                <TopBanner />
                <AllAudioReleases />
                <WorkshopSection />
                <MayaSenClass />
                <ImageGallery />
                <EventsGallery />
                <Publications />
                <AboutSection />
                <Footer />
              </div>
            }
          />

          {/* Admin Login */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Admin Panel with Nested Routes */}
          <Route path="/admin" element={<AdminPanel />}>
            <Route path="audio-releases" element={<AllAudioReleaseAdmin />} />
            <Route path="maya-class" element={<MayaClassAdmin />} />
            <Route path="workshops" element={<WorkshopsAdmin />} />
            <Route path="events-krc" element={<EventsKRCAdmin />} />
            <Route path="gallery" element={<ImageGalleryAdmin />} />
            <Route path="publications" element={<PublicationsAdmin />} />
            <Route index element={<p>Select a section from above.</p>} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
